import { getSrcs, getPreloadSrcs } from './img-process'

const commons = `/images/webp/commons`
const intro = `/images/webp/intro`
const main = `/images/webp/menu`
const stage1 = `/images/webp/stage1`
const stage2 = `/images/webp/stage2`
const stage3 = `/images/webp/stage3`
const stage4 = `/images/webp/stage4`
const stage5 = `/images/webp/stage5`
const stage6 = `/images/webp/stage6`
const end = `/images/webp/end`
const hints = `/images/webp/hints`

// common
const btnBack = `${commons}/btn-back.webp`
const btnNext = `${commons}/btn-next.webp`
const btnHint = `${commons}/btn-hint.webp`
const btnYes = `${commons}/btn-yes.webp`
const btnNo = `${commons}/btn-no.webp`
const bgModal = `${commons}/bg-modal.webp`
const bgModalStage = `${commons}/bg-modal-stage.webp`
const btnSubmit = `${commons}/btn-submit.webp`
const bgText = `${commons}/bg-text.webp`
const btnSuccess = `${commons}/btn-success.webp`
const musicOn = `${commons}/music-on.webp`
const musicOff = `${commons}/music-off.webp`
const btnPress = `${commons}/btn-press.webp`
const roles = {
  a: {
    correct: `${commons}/a-correct.webp`,
    name: `${commons}/a-name.webp`,
    role1: `${commons}/a-role1.webp`,
    role2: `${commons}/a-role2.webp`,
  },
  b: {
    correct: `${commons}/b-correct.webp`,
    name: `${commons}/b-name.webp`,
    role1: `${commons}/b-role1.webp`,
    role2: `${commons}/b-role2.webp`,
  },
  c: {
    correct: `${commons}/c-correct.webp`,
    name: `${commons}/c-name.webp`,
    role1: `${commons}/c-role1.webp`,
    role2: `${commons}/c-role2.webp`,
  },
  d: {
    correct: `${commons}/d-correct.webp`,
    name: `${commons}/d-name.webp`,
    role1: `${commons}/d-role1.webp`,
    role2: `${commons}/d-role2.webp`,
  },
  e: {
    correct: `${commons}/e-correct.webp`,
    name: `${commons}/e-name.webp`,
    role1: `${commons}/e-role1.webp`,
    role2: `${commons}/e-role2.webp`,
  },
}

export const imgCommons = {
  btnBack,
  btnNext,
  btnHint,
  btnYes,
  btnNo,
  bgModal,
  bgModalStage,
  btnSubmit,
  bgText,
  btnSuccess,
  musicOn,
  musicOff,
  roles,
  btnPress,
}

// /components/AppWrapper.tsx
export const imgAppWrapper = {
  appLogo: `/logo1024.png`,
}

// intros - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// /pages/intros/Welcome.tsx
export const imgWelcome = {
  btnEnter: `${intro}/btn-enter.webp`,
  bgWelcome: `${intro}/bg-welcome.webp`,
}

// /pages/intros/Intro.tsx
export const imgIntro = {
  bgIntro1: `${intro}/bg-intro1.webp`,
  bgIntro2: `${intro}/bg-intro2.webp`,
  bgRole: `${intro}/bg-role1.webp`,
  btnAgain: `${intro}/btn-again.webp`,
  btnStart: `${intro}/btn-start.webp`,
  btnYes: `${intro}/btn-yes.webp`,
  roles: getSrcs(5, `${intro}/role<R>`),
  btnNext,
  bgText,
  bgModal,
}

// /pages/stages/main/Main.tsx
export const imgMain = {
  bgMain: `${main}/bg-main.webp`,
  btnPass: `${main}/btn-stage-pass.webp`,
  maps: getSrcs(6, `${main}/map<R>`),
}
export const imgArrMain = {
  btnStages: getSrcs(6, `${main}/btn-stage<R>`),
}

export const stageCommon = (stage: string) => ({
  bgEnding1: `${stage}/bg-ending1.webp`,
  bgGame1: `${stage}/bg-game1.webp`,
  btnStory: `${stage}/btn-story.webp`,
  picStory1: `${stage}/pic-story1.webp`,
  roles,
  btnNext,
  bgModal,
  btnYes,
  btnBack,
  btnSubmit,
  btnSuccess,
  btnNo,
  bgMain: `${hints}/bg-hints.webp`,
})

// /pages/stages/stage1/Stage1.tsx
export const imgStage1 = {
  bgGame2: `${stage1}/bg-game2.webp`,
  bgEnding2: `${stage1}/bg-ending2.webp`,
  ...stageCommon(stage1),
}

// /pages/stages/stage2/Stage2.tsx
export const imgStage2 = {
  picStory2: `${stage2}/pic-story2.webp`,
  bgEnding2: `${stage2}/bg-ending2.webp`,
  ...stageCommon(stage2),
}

// /pages/stages/stage3/Stage3.tsx
export const imgStage3 = {
  picStory2: `${stage3}/pic-story2.webp`,
  bgEnding2: `${stage3}/bg-ending2.webp`,
  ...stageCommon(stage3),
}

// /pages/stages/stage4/Stage4.tsx
export const imgStage4 = {
  picStory2: `${stage4}/pic-story2.webp`,
  bgEnding2: `${stage4}/bg-ending2.webp`,
  ...stageCommon(stage4),
}

// /pages/stages/stage5/Stage5.tsx
export const imgStage5 = {
  ...stageCommon(stage5),
}
// /pages/stages/stage6/Stage6.tsx
export const imgStage6 = {
  picStory2: `${stage6}/pic-story2.webp`,
  ...stageCommon(stage6),
}

// /pages/stages/end/End.tsx
export const imgEnd = {
  bgEnd: `${end}/bg-end.webp`,
  bgEnd2: `${end}/bg-end2.webp`,
  bgSuccess: `${end}/bg-success.webp`,
  btnRestart: `${end}/btn-restart.webp`,
  btnVideo: `${end}/btn-video.webp`,
  diamond: `${end}/daimond.webp`,
  txtSuccess: `${end}/txt-success.webp`,
  btnNext,
}

// hints - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// /pages/hints/StageHints.tsx
export const imgHints = {
  btnYes: `${hints}/btn-yes.webp`,
  btnNo: `${hints}/btn-no.webp`,
  bgHints: `${hints}/bg-hints.webp`,
  bgQuestion: `${hints}/bg-question.webp`,
  bgModal: `${hints}/bg-modal.webp`,
  btnOpen: `${hints}/btn-open.webp`,
}

// /pages/hints/HintContainer.tsx
export const imgHintContainer = {
  btnOpen: `${hints}/btn-open.webp`,
}
export const imgArrHintContainer = {
  hintNums: getSrcs(2, `${hints}/bg-hint-num<R>`),
}

/* ========================================== preloads ========================================== */

export const all = [
  imgCommons,
  imgAppWrapper,
  imgWelcome,
  imgIntro,
  imgMain,
  imgArrMain,
  imgStage1,
  imgStage2,
  imgStage3,
  imgStage4,
  imgStage5,
  imgStage6,
  imgEnd,
  imgHints,
  imgHintContainer,
  imgArrHintContainer,
]

export const preloadImgs = getPreloadSrcs(all)
